import { z } from 'zod';
export const InviteGenerateRequest = z.object({
    target_room_id: z.string().nullable().default(null),
    target_game_id: z.string().nullable().default(null),
});
export const InviteGenerateResponse = z.object({
    code: z.string(),
    url: z.string().url(),
    share_text: z.string(),
    heat_at_share: z.number().int().min(0).max(100).nullable(),
    expires_at: z.string(),
    reward_invitee: z.number().int(),
    reward_inviter: z.number().int(),
});
export const InviteResolveRequest = z.object({
    code: z.string(),
});
export const InviteResolveResponse = z.object({
    code: z.string(),
    status: z.enum(['valid', 'claimed', 'expired', 'flagged', 'not_found']),
    inviter: z
        .object({
        user_id: z.string(),
        username: z.string(),
        display_name: z.string(),
        avatar_url: z.string().nullable(),
    })
        .nullable(),
    target_room_id: z.string().nullable(),
    target_game_id: z.string().nullable(),
    heat_at_share: z.number().int().min(0).max(100).nullable(),
    reward_invitee: z.number().int(),
    expires_at: z.string(),
});
export const InviteRedeemRequest = z.object({
    code: z.string(),
});
export const InviteRedeemResponse = z.object({
    code: z.string(),
    redeemed: z.boolean(),
    invitee_bonus_applied: z.number().int(),
    friendship_created: z.boolean(),
    routed_to_room_id: z.string().nullable(),
    message: z.string(),
});
export const InviteListMineRequest = z.object({
    limit: z.number().int().min(1).max(100).default(50),
    offset: z.number().int().min(0).default(0),
    status: z.enum(['all', 'unclaimed', 'claimed', 'expired']).default('all'),
});
export const InviteSummary = z.object({
    invite_id: z.number().int(),
    code: z.string(),
    url: z.string().url(),
    target_room_id: z.string().nullable(),
    target_game_id: z.string().nullable(),
    heat_at_share: z.number().int().min(0).max(100).nullable(),
    claimed_by_user_id: z.string().nullable(),
    claimed_by_display_name: z.string().nullable(),
    claimed_at: z.string().nullable(),
    reward_inviter_paid: z.boolean(),
    created_at: z.string(),
    expires_at: z.string(),
});
export const InviteListMineResponse = z.object({
    items: z.array(InviteSummary),
    total: z.number().int(),
    reward_inviter_paid_total: z.number().int(),
});
//# sourceMappingURL=invites.js.map